import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-white md:text-lg text-md px-2 py-1 rounded-lg cursor-pointer border text-center" }




export default /*#__PURE__*/_defineComponent({
  __name: 'SecondaryButton',
  props: {
    label: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, _toDisplayString(props.label), 1))
}
}

})